// ** Third Party Components
import {Edit} from 'react-feather'

// ** Table Common Column
export const columns = (toggleModal) => [
  {
    name: 'No Firmante',
    width: '15%',
    center: true,
    selector: row => row.id,
    sortable: true,
    cell: row => (
      <div className='d-flex align-items-center text-center'>
        {row.id}
      </div>
    )
  },
  {
    name: 'Nombre de firmante',
    width: '25%',
    sortable: true,
    center: true,
    selector: row => row.fullName
  },
  {
    name: 'Pais',
    width: '15%',
    omit: false,
    sortable: true,
    center: true,
    selector: row => row.country
  },
  {
    name: 'Tipo de documento',
    width: '15%',
    omit: false,
    sortable: true,
    center: true,
    selector: row => row.documentType
  },
  /*{
    name: 'Estado',
    width: '12%',
    omit: true,
    sortable: true,
    center: true,
    selector: row => row.status
  },
  {
    name: 'Fecha de Creación',
    width: '20%',
    center: true,
    sortable: true,
    selector: row => row.createDate,
  },
  {
    name: 'Tipo de firmante',
    width: '15%',
    center: true,
    sortable: true,
    selector: row => row.signerType,
  },*/
  {
    name: 'Sociedad',
    width: '20%',
    center: true,
    sortable: true,
    selector: row => row.company,
  },
  {
    name: 'Acciones',
    width: '10%',
    center: true,
    allowOverflow: true,
    cell: (row) => {
      return (
        <div className='d-flex'>
          <div className='cursor-pointer text-primary'>
            <Edit onClick={() => toggleModal(true, row)} size={20} />
          </div>
          {/*<div className='ps-1 cursor-pointer'>
              <Trash size={20} />
          </div>*/}
        </div>
      )
    }
  }
]
